
import React from "react";

import { Icon, PlainButton } from "@culturehq/components";
import { Story } from "chq";
import { useGaTracking } from "app/hooks";
import { Trans } from "app/utils";

interface SearchCareerLinkProps {
  buttonClass: string;
  organizationId: number;
  story: Story;
  url: string;
}

const SearchCareerLink: React.FC<SearchCareerLinkProps> = ({
  story, organizationId, url, buttonClass
}) => {
  const { trackEvent } = useGaTracking();

  const trackClick = () => {
    trackEvent({
      organizationId,
      storyId: story.id,
      eventAction: "click_search_careers",
      url: window.location.href,
      type: "culture_page"
    });
  };

  return (
    <a href={url} target="_blank" rel="noopener noreferrer" onClick={trackClick}>
      <PlainButton className={buttonClass}>
        <Trans>Search Careers</Trans>
        <Icon icon="arrow-left-c" />
      </PlainButton>
    </a>
  );
};

export default SearchCareerLink;
